import { connect } from 'react-redux';
import {
  isBVWebEnabled,
  isPixleeWebEnabled,
  getIsStyleColorRnREnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import ProductReviewsWidget from '../views/ProductReviewsWidget.view';

const mapStateToProps = (state) => ({
  isPixleeWidget: isPixleeWebEnabled(state),
  isBVWidget: isBVWebEnabled(state),
  isStyleColorRnREnabled: getIsStyleColorRnREnabled(state),
});

export default connect(mapStateToProps, null)(ProductReviewsWidget);
